import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=572beeb8&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"
import style0 from "./Auth.vue?vue&type=style&index=0&id=572beeb8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572beeb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('572beeb8')) {
      api.createRecord('572beeb8', component.options)
    } else {
      api.reload('572beeb8', component.options)
    }
    module.hot.accept("./Auth.vue?vue&type=template&id=572beeb8&scoped=true", function () {
      api.rerender('572beeb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Auth.vue"
export default component.exports